import React from 'react'

import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'
import BasicLgySelectField from 'app/components/util/lgy-select-field/BasicLgySelectField'
import LgyFormSubmit from 'app/components/util/lgy-form-submit/LgyFormSubmit'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import BasicLgyCheckbox from 'app/components/util/lgy-checkbox/BasicLgyCheckbox'

import builderStates from '../../constants/builder-states'
import { searchTypes } from '../../constants/search-types'
import '../../style/builder-form.scss'

const BuilderForm = ({ handleSubmit, handleChange, handleInvalid, handleReset, homeBuilder, values, errors, stations }) =>
  <div className='builder builder-form usa-grid'>
    <h1>Request a Customized Builder Report</h1>
    {homeBuilder.list && homeBuilder.list.length < 1 &&
      <LgyAlertDialog type='error' heading='Not Found' text='No builders were found that match the search criteria.' />}
    <form onSubmit={handleSubmit}>
      <fieldset className='builder-name-id'>
        <legend className='instructions'>1. Enter the builder name (partial entry OK) and/or the full 5-digit alphanumeric ID.</legend>
        <div className='usa-width-one-half'>
          <BasicLgyInputField label='Name' type='text' id='name' name='name' value={values.name} onChange={handleChange} autoFocus />
          <div>
          <legend className='usa-sr-only'>Select Builder Name Search Type</legend>
          <ul className='usa-unstyled-list search-types'>
            <li>
              <BasicLgyCheckbox id='starts-with' type='radio' name='searchType' label='Starts with' value='STARTS_WITH' checked={values.searchType === searchTypes.STARTS_WITH} onChange={handleChange} />
            </li>
            <li>
              <BasicLgyCheckbox id='contains' type='radio' name='searchType' label='Contains' value='CONTAINS' checked={values.searchType === searchTypes.CONTAINS} onChange={handleChange} />
            </li>
          </ul>
      </div>
        </div>
        <div className='usa-width-one-half'>
          <BasicLgyInputField className='usa-input-medium' label='ID' type='text' id='id' name='id' value={values.id} onChange={handleChange}
            maxLength='5' pattern='[a-zA-Z0-9]{5}' onInvalid={handleInvalid} error={errors.id ? errors.id : undefined} />
        </div>
      </fieldset>
      <fieldset className='builder-region'>
        <legend className='instructions'>2. Select the Regional Office with which the builder is registered.</legend>
        <BasicLgySelectField label='Regional Office' id='station' name='station' placeholder='All Offices' value={values.station} onChange={handleChange}>
          {stations && stations.map(station => <option key={station.stationNumber} value={station.stationNumber}>{station.stationCity}</option>)}
        </BasicLgySelectField>
      </fieldset>
      <fieldset className='builder-city-state'>
        <legend className='instructions'>3. Enter the builder's location information. State is required.</legend>
        <div className='usa-width-one-half'>
          <BasicLgyInputField label='City' type='text' id='city' name='city' value={values.city} onChange={handleChange} />
        </div>
        <div className='usa-width-one-half'>
          <BasicLgySelectField label='State' id='stateCode' name='stateCode' placeholder='State' value={values.stateCode}
            onChange={handleChange} required onInvalid={handleInvalid} error={errors.stateCode ? errors.stateCode : undefined}>
            {builderStates.map(state => <option key={state.cd} value={state.cd}>{state.label}</option>)}
          </BasicLgySelectField>
        </div>
      </fieldset>
      <fieldset className='principal-name-id'>
        <legend className='instructions'>4. Enter the first and/or last name of the builder principal (partial entry OK).</legend>
        <div className='usa-width-one-half'>
          <BasicLgyInputField label='First Name' type='text' id='firstName' name='firstName' value={values.firstName} onChange={handleChange} />
        </div>
        <div className='usa-width-one-half'>
          <BasicLgyInputField label='Last Name' type='text' id='lastName' name='lastName' value={values.lastName} onChange={handleChange} />
        </div>
      </fieldset>
      <LgyFormSubmit
        pristine={values.name === '' && values.id === '' && values.city === '' && values.station === ''
          && values.stateCode === '' && values.firstName === '' && values.lastName === ''}
        submitting={homeBuilder.fetching}
        submitFailed={homeBuilder.error}
        invalid={errors.stateCode || errors.id}
        reset={handleReset} />
    </form>
  </div>

export default BuilderForm